<template>
  <div class="content-builder">
    <div class="form-group">
      <label class="control-label" for="question-wysiwyg">Question Text</label>
      <QuillEditor v-model:content="content.question.text" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>
    <div class="form-group">
      <label class="control-label" for="question-text-classes">Question Text CSS Classes</label>
      <input id="question-text-classes" v-model="content.questionTextClasses" class="form-control" type="text">
    </div>
    <div class="form-group">
      <label class="control-label" for="user-input-classes">User Input CSS Classes</label>
      <input id="user-input-classes" v-model="content.userInputClasses" class="form-control" type="text">
    </div>
    <div class="form-group">
      <label class="control-label">Question Image</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <a class="btn btn-primary text-white" data-input="question-image" data-lfm="image">
            <i class="fa fa-image"></i>
          </a>
        </div>
        <input id="question-image" v-model="content.questionImage" class="form-control" type="text">
      </div>
    </div>
    <AnimationControlsComponent :content="content"></AnimationControlsComponent>
    <div class="form-group">
      <label class="control-label" for="feedback-wysiwyg">Feedback Instruction Text</label>
      <QuillEditor v-model:content="content.feedback.text" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>
    <ChoiceListComponent :content="content" :opts="choiceListOpts"/>
  </div>
</template>

<script>
import _ from 'lodash'
import {defaultMeters} from '../../../common/metrics'
import layoutMixin from '../../mixins/layout'
import ChoiceListComponent from '../ChoiceListComponent.vue'
import AnimationControlsComponent from "../AnimationControlsComponent.vue";
import {EDITOR_CONFIG_BUTTONS_FULL} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {AnimationControlsComponent, ChoiceListComponent, QuillEditor},
  mixins: [layoutMixin],
  data() {
    const content = _.cloneDeep(this.source)
    const filled = _.defaults(content, {
      question: {
        text: '',
        timeLimit: false,
        multiselect: true,
        randomize: false,
        responses: [],
        animationEffects: {
          responseDisplay: '',
          responseStartDelay: 0,
          responseBetweenDelay: 0.2
        },
        questionTextClasses: '',
        userInputClasses: ''
      },
      feedback: {
        text: ''
      },
      choicePage: {
        text: ''
      }
    })

    const choiceListOpts = {
      feedbackInput: true,
      feedbackImage: false,
      outcomeTrigger: true,
      flowHook: true
    }

    // pre-fill with default data
    filled.question.responses.forEach((response) => {
      if (!response.meters || !response.meters.length) {
        response.meters = defaultMeters()
      }
    })

    if (!_.get(content, 'showOutcomeOfZero')) {
      content.showOutcomeOfZero = false;
    }

    if (!_.get(filled.question, 'questionTextClasses')) {
      filled.question.questionTextClasses = ''
    }

    if (!_.get(filled.question, 'animationEffects')) {
      filled.question.animationEffects = {
        responseDisplay: '',
        responseStartDelay: 0,
        responseBetweenDelay: 0.2
      }
    }

    return {
      content: filled,
      choiceListOpts: choiceListOpts,
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL
    }
  },
  methods: {
    setContent() {
    },
    getValue() {
      return this.content
    }
  }
}
</script>
